// extracted by mini-css-extract-plugin
export default {"maincontainer":"User_maincontainer__UWSGb","header":"User_header__XXQcF","btn_color":"User_btn_color__W8Ahg","btn_colordis":"User_btn_colordis__X7P1U","holder":"User_holder__DYO2v"};